import { formatPhone, phoneDigits, telegramText, telegramUrl, usageShort } from "../../utils/phoneFormat";

/**
 * Телефоны, почты и Telegram человека с пометкой, чей это контакт: «(раб.)», «(личн.)», «(общий)»,
 * «(не указан)» (Чат 4, доработка №15, 04.11). [Claude] 2026-11-04
 * Профиль даёт одно значение каждого вида (тип — employee.phone_usage и т. д.), остальные — из «Контактов».
 */
const PROFILE_FIELD = { phone: "phone_number", email: "email", telegram: "telegram_username" };
const USAGE_FIELD = { phone: "phone_usage", email: "email_usage", telegram: "telegram_usage" };

const keyOf = (type, value) => {
    if (type === "phone") return phoneDigits(value) || String(value || "").replace(/\D/g, "");
    return String(value || "").trim().toLowerCase().replace(/^@/, "");
};

/** [{value, usage, source}] — the profile value first, then active contacts of the same type, no duplicates. */
export function contactItems(employee, contacts = [], type) {
    const out = [];
    const seen = new Set();
    const push = (value, usage, source) => {
        if (!value) return;
        const key = keyOf(type, value);
        if (!key || seen.has(key)) return;
        seen.add(key);
        out.push({ value, usage: usage || null, source });
    };
    push(employee?.[PROFILE_FIELD[type]], employee?.[USAGE_FIELD[type]], "profile");
    (contacts || []).filter((c) => c.type === type).forEach((c) => push(c.value, c.usage, "contact"));
    return out;
}

export function contactDisplay(type, value) {
    if (type === "phone") return formatPhone(value);
    if (type === "telegram") return telegramText(value);
    return value;
}

export function ContactValue({ type, value, className = "" }) {
    const text = contactDisplay(type, value);
    const stop = (event) => event.stopPropagation();
    if (type === "telegram") {
        const url = telegramUrl(value);
        return url ? <a href={url} target="_blank" rel="noopener noreferrer" onClick={stop} className={`text-sky-700 hover:underline ${className}`} title="Открыть в Telegram">{text}</a> : <span className={className}>{text}</span>;
    }
    if (type === "email") return <a href={`mailto:${value}`} onClick={stop} className={`hover:underline ${className}`}>{text}</a>;
    if (type === "phone" && phoneDigits(value)) return <a href={`tel:+${phoneDigits(value)}`} onClick={stop} className={`whitespace-nowrap hover:underline ${className}`}>{text}</a>;
    return <span className={className}>{text}</span>;
}

/** Cell / tile content: one value per line with its usage in brackets. */
export default function ContactValues({ items, type, empty = "—", testId }) {
    if (!items?.length) return <span className="text-slate-400">{empty}</span>;
    return <span className="flex flex-col gap-0.5" data-testid={testId}>
        {items.map((item) => <span key={`${item.source}-${item.value}`} className="leading-snug">
            <ContactValue type={type} value={item.value} />
            <span className={`ml-1 text-[11px] font-normal ${item.usage ? "text-slate-400" : "text-amber-600"}`}>({usageShort(item.usage)})</span>
        </span>)}
    </span>;
}
